module.exports = __webpack_public_path__ + "img/entranceGuard.fedb1e30.png";